import React from 'react';
import { Auth } from 'aws-amplify';
import Box from '@amzn/awsui-components-react/polaris/box';
import Button from '@amzn/awsui-components-react/polaris/button';
import Container from '@amzn/awsui-components-react/polaris/container';
import Grid from '@amzn/awsui-components-react/polaris/grid';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';

const LoginContent: React.FC = () => {
  const handleLogin = () => {
    Auth.federatedSignIn({ customProvider: "FederateOIDC" });
  };

  return (
    <div className="custom-home__header">
      <Box padding={{ vertical: 'xxxl', horizontal: 's' }}>
        <Grid
          gridDefinition={[
            { offset: { l: 2, xxs: 1 }, colspan: { l: 8, xxs: 10 } },
            { colspan: { xl: 6, l: 5, s: 6, xxs: 10 }, offset: { l: 2, xxs: 1 } },
            { colspan: { xl: 2, l: 3, s: 4, xxs: 10 }, offset: { s: 0, xxs: 1 } },
          ]}
        >
          <Box fontWeight="light" padding={{ top: 'xs' }}>
            <span className="custom-home__category">I can haz webpage?</span>
          </Box>
          <div className="custom-home__header-title">
            <Box variant="h1" fontWeight="heavy" padding="n" fontSize="display-l" color="inherit">
              Oops!
            </Box>
            <Box fontWeight="light" padding={{ bottom: 's' }} fontSize="display-l" color="inherit">
              Looks like you stumbled upon an internal Amazon site
            </Box>
            <Box variant="p" fontWeight="light">
              <span className="custom-home__header-sub-title">
                If you're lost you can close this window. There's nothing to see here.
              </span>
            </Box>
          </div>
          <div className="custom-home__header-cta">
            <Container>
              <SpaceBetween size="xl">
                <Box variant="h2" padding="n">
                  Amazon employees
                </Box>
                <Box>
                  You may use this button to log in.
                </Box>
                <Button variant="primary" onClick={handleLogin}>
                  Login
                </Button>
              </SpaceBetween>
            </Container>
          </div>
        </Grid>
      </Box>
    </div>
  );
};

export default LoginContent;